import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function EnterprisePage() {
  return <IndustryDetailPage slug="enterprise" />;
}